<template>
  <div class="intro-recommand-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <!-- 搜索推荐平台价值 -->
    <common-advantage :advantages="valuesList"></common-advantage>
    <!-- 搜索推荐平台优势 -->
    <common-advantage :advantages="advantageList"></common-advantage>
    <div class="application-wrap resolution-wrap">
      <common-application title="推荐搜索平台解决方案" :tabfilter="tabsfilter" :tabcontent="tabcontent"></common-application>
    </div>
    <div class="application-wrap appcase-wrap">
      <common-application title="推荐搜索平台应用案例" :tabfilter="tabsfilter2" :tabcontent="tabcontent2"></common-application>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
import application from '@/components/application'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage,
    'common-application': application
  },
  data () {
    return {
      tabsfilter: ['内容生产', '内容抓取', '内容处理', '内容审核'],
      tabcontent: ['rs-banner1', 'rs-banner2', 'rs-banner3', 'rs-banner4'],
      tabsfilter2: ['之家APP接入智能推荐搜索产品', '某资讯APP接入之家智能搜索推荐产品'],
      tabcontent2: ['rs-banner5', 'rs-banner6'],
      currentTabIndex: 0,
      currentTabIndex2: 0,
      hoverIndex: -1,
      valuesList: {
        title: '推荐搜索平台价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: '曝光与转化',
            desc: '提升内容/广告的曝光与转化',
            iconname: 'icon-rs-01'
          },
          {
            key: '1',
            title: '用户增长',
            desc: '提升用户转化率、留存、活跃、停留时长等关键指标',
            iconname: 'icon-rs-02'
          },
          {
            key: '2',
            title: '内容生态',
            desc: '促进企业的内容生态繁荣',
            iconname: 'icon-rs-03'
          },
          {
            key: '3',
            title: '经济效益',
            desc: '提升分发效率， 为企业带来直接经济效益',
            iconname: 'icon-rs-04'
          }
        ]
      },
      advantageList: {
        title: '推荐搜索平台优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '快速接入',
            desc: '自动化接入智能推荐，可在一周内完成完整搜索推荐能力输出',
            iconname: 'icon-rs-05'
          },
          {
            key: '1',
            title: '精准推荐效果',
            desc: '基于用户画像和海量用户实时行为数据，同时结合完善的物料处理，实现精准推荐',
            iconname: 'icon-rs-06'
          },
          {
            key: '2',
            title: '灵活推荐策略',
            desc: '多样化的召回、排序、过滤、量控、打散、调权策略，确保搜索推荐策略的灵活',
            iconname: 'icon-rs-07'
          },
          {
            key: '3',
            title: '丰富运营管理功能',
            desc: '资源管理、流量管理、推荐策略管理、数据管理、实验管理等丰富的管理功能，实现搜索推荐运营管理的平台化操作',
            iconname: 'icon-rs-08'
          },
          {
            key: '4',
            title: '一站式效果分析',
            desc: '资源数据、搜索&推荐效果数据、用户数据等搜索推荐效果数据一键配置报表，一站式分析',
            iconname: 'icon-rs-09'
          }
        ]
      }
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1725,
    }
    window.trackPageView()
  },
  methods: {}
}
</script>

<style scoped>
.intro-recommand-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 544px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner3.png');
  background-repeat: no-repeat;
  background-position: -2px 0;
}
.application-wrap {
  margin-bottom: -2px;
}
.resolution-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 50px;
}
.appcase-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 0;
}
.intro-recommand-container .application-title .line i {
  background: rgba(202,206,213,.5);
}
</style>



// WEBPACK FOOTER //
// src/view/intro_recommand.vue